/*!
 * Accessibility Widget — תפריט נגישות עצמאי (ללא תלויות)
 * הטמעה: <script src="accessibility-widget.js" defer></script> לפני </body>
 * הגדרות אופציונליות (לפני טעינת הסקריפט):
 *   <script>window.A11Y_WIDGET_CONFIG = { position: 'right', statementUrl: '/pages/accessibility' };</script>
 */
(function () {
  'use strict';
  if (window.__a11yWidgetLoaded) return;
  window.__a11yWidgetLoaded = true;

  /* ------------------------------------------------------------------ */
  /* הגדרות                                                               */
  /* ------------------------------------------------------------------ */
  var USER = window.A11Y_WIDGET_CONFIG || {};
  var CONFIG = {
    position: USER.position || 'right',          // 'right' | 'left'
    offsetBottom: USER.offsetBottom != null ? USER.offsetBottom : 0,
    offsetSide: USER.offsetSide != null ? USER.offsetSide : 0,
    buttonSize: USER.buttonSize || 45,          // בטלפון: 34
    statementUrl: USER.statementUrl || '/pages/accessibility-statement',
    zIndex: USER.zIndex || 2147483000,
    colors: Object.assign({
      primary: '#000000',      // כותרת הפאנל וכפתור הפתיחה
      background: '#f6f6f6',   // רקע הפאנל
      text: '#636363',         // צבע תוויות
      title: '#105675',        // כותרות הסליידרים
      active: '#118f38',       // מצב פעיל
      focus: '#177fab',        // מסגרת פוקוס
      sliderStart: '#b586ff',
      sliderEnd: '#177fab'
    }, USER.colors || {})
  };

  var STORAGE_KEY = 'a11y-widget-v1';
  var HOST_ID = 'a11y-widget-host';
  var C = CONFIG.colors;
  var Z = CONFIG.zIndex;

  var DEFAULTS = {
    colorMode: null,     // 'high-contrast' | 'invert' | 'grayscale' | 'bw'
    links: false,
    tts: false,
    fontScale: 100,
    wordSpacing: 0,
    letterSpacing: 0,
    readableFont: false,
    hideImages: false,
    srAdjust: false,
    cursor: null,        // 'dark' | 'light'
    readingGuide: false,
    noAnim: false,
    headings: false
  };

  var state = load();

  function load() {
    var s = Object.assign({}, DEFAULTS);
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (raw) Object.assign(s, JSON.parse(raw));
    } catch (e) { /* storage blocked */ }
    return s;
  }
  function save() {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) { /* ignore */ }
  }

  /* ------------------------------------------------------------------ */
  /* אייקונים                                                            */
  /* ------------------------------------------------------------------ */
  function svg(inner, fill) {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="' + (fill ? 'currentColor' : 'none') +
      '" stroke="' + (fill ? 'none' : 'currentColor') + '" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' + inner + '</svg>';
  }
  var ICONS = {
    person: svg('<circle cx="12" cy="4" r="2.2"/><path d="M19.6 8.2c-2.4.7-4.9 1-7.6 1s-5.2-.3-7.6-1l-.5 1.9c1.7.5 3.5.8 5.3 1v2.4L7 21l1.9.6 2.4-6.6h1.4l2.4 6.6L17 21l-2.2-7.5v-2.4c1.8-.2 3.6-.5 5.3-1z"/>', true),
    close: svg('<path d="M5 5l14 14M19 5L5 19" stroke-width="2.4"/>'),
    plus: svg('<path d="M12 5v14M5 12h14" stroke-width="2"/>'),
    minus: svg('<path d="M5 12h14" stroke-width="2"/>'),
    sun: svg('<circle cx="12" cy="12" r="3.6"/><path d="M12 2.5v2.2M12 19.3v2.2M2.5 12h2.2M19.3 12h2.2M5.3 5.3l1.6 1.6M17.1 17.1l1.6 1.6M5.3 18.7l1.6-1.6M17.1 6.9l1.6-1.6"/>'),
    moon: svg('<path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z"/>'),
    half: svg('<circle cx="12" cy="12" r="8.5"/><path d="M12 3.5a8.5 8.5 0 0 0 0 17z" fill="currentColor"/>'),
    contrast: svg('<circle cx="12" cy="12" r="8.5"/><path d="M12 3.5a8.5 8.5 0 0 1 0 17z" fill="currentColor"/>'),
    link: svg('<path d="M10 14a4.5 4.5 0 0 0 6.4 0l3-3a4.5 4.5 0 0 0-6.4-6.4l-1.3 1.3"/><path d="M14 10a4.5 4.5 0 0 0-6.4 0l-3 3a4.5 4.5 0 0 0 6.4 6.4l1.3-1.3"/>'),
    wave: svg('<path d="M2 12h3M7 9v6M10 5v14M13 8v8M16 3v18M19 9v6M22 12h-1"/>'),
    font: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><text x="1" y="18" font-size="13" font-family="Georgia,serif" fill="currentColor">A</text><text x="12" y="18" font-size="13" font-family="Arial,sans-serif" font-weight="700" fill="currentColor">A</text></svg>',
    noImage: svg('<rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="8.5" cy="10" r="1.5"/><path d="M21 15l-5-5-8 9"/><path d="M3 3l18 18"/>'),
    braille: svg('<circle cx="8" cy="5" r="1.6"/><circle cx="16" cy="5" r="1.6"/><circle cx="8" cy="10" r="1.6"/><circle cx="16" cy="10" r="1.6"/><circle cx="12" cy="10" r="1.6"/><circle cx="8" cy="15" r="1.6"/><circle cx="12" cy="15" r="1.6"/><circle cx="16" cy="15" r="1.6"/><circle cx="12" cy="20" r="1.6"/><circle cx="12" cy="5" r="1.6"/>', true),
    cursorDark: svg('<path d="M6 3l13 8.5-6 1.4L10 19z"/>', true),
    cursorLight: svg('<path d="M6 3l13 8.5-6 1.4L10 19z"/>'),
    glasses: svg('<circle cx="6.5" cy="14" r="3.5"/><circle cx="17.5" cy="14" r="3.5"/><path d="M10 14c1.2-1 2.8-1 4 0M3 14l1-6M21 14l-1-6"/>'),
    noAnim: svg('<circle cx="12" cy="12" r="8.5"/><path d="M10 9v6M14 9v6"/>'),
    heading: svg('<path d="M7 4v11M17 4v11M7 9.5h10M5 20h14"/>'),
    reset: svg('<path d="M4 12a8 8 0 1 0 2.4-5.7L4 8.5"/><path d="M4 3.5v5h5"/>')
  };

  /* ------------------------------------------------------------------ */
  /* הגדרת הכלים                                                          */
  /* ------------------------------------------------------------------ */
  var TILES_TOP = [
    { kind: 'color', value: 'high-contrast', label: 'ניגודיות גבוהה', icon: 'sun' },
    { kind: 'color', value: 'invert', label: 'ניגודיות הפוכה', icon: 'moon' },
    { kind: 'color', value: 'grayscale', label: 'גווני אפור', icon: 'half' },
    { kind: 'color', value: 'bw', label: 'שחור לבן', icon: 'contrast' },
    { kind: 'bool', key: 'links', label: 'הדגשת קישורים', icon: 'link' },
    { kind: 'bool', key: 'tts', label: 'הקראת טקסט', icon: 'wave' }
  ];
  var TILES_BOTTOM = [
    { kind: 'bool', key: 'readableFont', label: 'גופן קריא', icon: 'font' },
    { kind: 'bool', key: 'hideImages', label: 'הסתרת תמונות', icon: 'noImage' },
    { kind: 'bool', key: 'srAdjust', label: 'התאמה לקוראי מסך', icon: 'braille' },
    { kind: 'cursor', value: 'dark', label: 'סמן גדול כהה', icon: 'cursorDark' },
    { kind: 'cursor', value: 'light', label: 'סמן גדול בהיר', icon: 'cursorLight' },
    { kind: 'bool', key: 'readingGuide', label: 'מדריך קריאה', icon: 'glasses' },
    { kind: 'bool', key: 'noAnim', label: 'ביטול אנימציות', icon: 'noAnim' },
    { kind: 'bool', key: 'headings', label: 'הדגשת כותרות', icon: 'heading' },
    { kind: 'reset', label: 'איפוס הגדרות', icon: 'reset' }
  ];
  var SLIDERS = [
    { key: 'fontScale', title: 'התאמת גודל גופן', inc: 'הגדלת טקסט', reset: 'איפוס גודל', dec: 'הקטנת טקסט',
      min: 70, max: 200, step: 10, fmt: function (v) { return v + '%'; } },
    { key: 'wordSpacing', title: 'התאמת ריווח בין מילים', inc: 'הגדלת ריווח', reset: 'איפוס ריווח', dec: 'הקטנת ריווח',
      min: -3, max: 10, step: 1, fmt: String },
    { key: 'letterSpacing', title: 'התאמת ריווח בין אותיות', inc: 'הגדלת ריווח', reset: 'איפוס ריווח', dec: 'הקטנת ריווח',
      min: -3, max: 10, step: 1, fmt: String }
  ];
  var ALL_TILES = TILES_TOP.concat(TILES_BOTTOM);

  /* ------------------------------------------------------------------ */
  /* CSS גלובלי — משפיע על האתר עצמו (לא על התפריט)                        */
  /* ------------------------------------------------------------------ */
  var NOT_HOST = ':not(#' + HOST_ID + ')';
  var cursorSvg = function (fill, stroke) {
    return 'url("data:image/svg+xml,' + encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"><path d="M5 2l15 10-7 1.6L9.6 21z" fill="' + fill + '" stroke="' + stroke + '" stroke-width="1.4" stroke-linejoin="round"/></svg>'
    ) + '") 6 3, auto';
  };
  var GLOBAL_CSS = [
    /* קישור דילוג */
    '.a11y-skip-link{position:absolute!important;top:-200px;right:8px;z-index:' + Z + ';background:#000!important;color:#fff!important;padding:12px 18px!important;font:700 16px/1.2 Arial,sans-serif!important;border-radius:6px;text-decoration:none!important}',
    '.a11y-skip-link:focus{top:8px}',

    /* ניגודיות גבוהה: רקע שחור, טקסט לבן, קישורים צהובים */
    'html.a11y-high-contrast body, html.a11y-high-contrast body *' + NOT_HOST + '{background-color:#000!important;color:#fff!important;border-color:#fff!important;text-shadow:none!important;box-shadow:none!important}',
    'html.a11y-high-contrast body a, html.a11y-high-contrast body a *{color:#ff0!important}',
    'html.a11y-high-contrast body :is(button,input,select,textarea){border:1px solid #fff!important}',
    'html.a11y-high-contrast body :is(button,[role=button]), html.a11y-high-contrast body :is(button,[role=button]) *{color:#0ff!important}',

    /* הדגשת קישורים */
    'html.a11y-links body :is(a,[role=link])' + NOT_HOST + '{text-decoration:underline!important;outline:2px solid #ffd400!important;outline-offset:1px!important;background-color:#ffff8c!important;color:#000!important}',
    'html.a11y-links body :is(a,[role=link]) *{color:#000!important}',

    /* הדגשת כותרות */
    'html.a11y-headings body :is(h1,h2,h3,h4,h5,h6,[role=heading]){outline:3px solid ' + C.focus + '!important;outline-offset:3px!important}',

    /* ריווח */
    'html.a11y-word-spacing body *' + NOT_HOST + '{word-spacing:var(--a11y-word-spacing)!important}',
    'html.a11y-letter-spacing body *' + NOT_HOST + '{letter-spacing:var(--a11y-letter-spacing)!important}',

    /* גופן קריא — לא נוגע בפונטי אייקונים */
    'html.a11y-readable-font body *' + NOT_HOST + ':not(i):not([class*="icon"]):not([class*="fa-"]):not([class*="material"]):not(svg):not(svg *){font-family:Arial,"Helvetica Neue",Helvetica,sans-serif!important}',

    /* הסתרת תמונות */
    'html.a11y-hide-images body :is(img,picture,video,canvas,[role=img]){visibility:hidden!important}',
    'html.a11y-hide-images body *' + NOT_HOST + '{background-image:none!important}',

    /* סמן גדול */
    'html.a11y-cursor-dark, html.a11y-cursor-dark body *' + NOT_HOST + '{cursor:' + cursorSvg('#000', '#fff') + '!important}',
    'html.a11y-cursor-light, html.a11y-cursor-light body *' + NOT_HOST + '{cursor:' + cursorSvg('#fff', '#000') + '!important}',

    /* ביטול אנימציות */
    'html.a11y-no-anim body *' + NOT_HOST + ', html.a11y-no-anim body *::before, html.a11y-no-anim body *::after{animation-duration:0.001ms!important;animation-iteration-count:1!important;animation-delay:0s!important;transition-duration:0.001ms!important;transition-delay:0s!important;scroll-behavior:auto!important}',

    /* התאמה לקוראי מסך — פוקוס בולט */
    'html.a11y-sr body :focus{outline:3px solid ' + C.focus + '!important;outline-offset:2px!important}',

    /* הקראת טקסט — סימון האלמנט הנקרא */
    '.a11y-tts-current{outline:3px dashed ' + C.focus + '!important;outline-offset:2px!important}'
  ].join('\n');

  /* ------------------------------------------------------------------ */
  /* CSS של התפריט (בתוך Shadow DOM — מבודד מה-CSS של האתר)               */
  /* ------------------------------------------------------------------ */
  var side = CONFIG.position === 'left' ? 'left' : 'right';
  var other = side === 'right' ? 'left' : 'right';
  var hiddenX = side === 'right' ? '100%' : '-100%';
  var BS = CONFIG.buttonSize;
  var BS_MOBILE = Math.min(BS, 34);
  var PANEL_W = 450;
  var dir = side === 'right' ? -1 : 1;
  // לשונית צמודה לקצה המסך, מעוגלת רק בצד הפנימי (כמו ב-Goom)
  var tabRadius = side === 'right' ? '10px 0 0 10px' : '0 10px 10px 0';

  var WIDGET_CSS = [
    ':host{all:initial}',
    '*{box-sizing:border-box;font-family:Arial,"Helvetica Neue",Helvetica,sans-serif;letter-spacing:normal;word-spacing:normal;line-height:1.3}',
    'button,a{font:inherit;color:inherit}',
    'svg{direction:ltr;flex:none}',
    ':focus{outline:none}',
    ':focus-visible{outline:3px solid ' + C.focus + ';outline-offset:2px}',
    '.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}',

    '.overlay{position:fixed;inset:0;pointer-events:none;z-index:' + (Z - 2) + ';display:none}',
    '.guide{position:fixed;left:0;right:0;top:0;height:12px;margin-top:-6px;background:rgba(0,0,0,.85);border-top:2px solid #ffd400;border-bottom:2px solid #ffd400;pointer-events:none;z-index:' + (Z - 1) + ';display:none;will-change:transform}',

    '.toggler{position:fixed;bottom:calc(' + CONFIG.offsetBottom + 'px + env(safe-area-inset-bottom, 0px));' + side + ':' + CONFIG.offsetSide + 'px;width:' + BS + 'px;height:' + BS + 'px;background:' + C.primary + ';color:#fff;border:0;border-radius:' + tabRadius + ';display:grid;place-items:center;cursor:pointer;z-index:' + (Z + 2) + ';transition:transform .3s ease,background-color .2s;padding:0}',
    '.toggler:hover{opacity:.88}',
    '.toggler.has-active{background:' + C.active + '}',
    '.toggler.open{transform:translateX(' + (dir * PANEL_W) + 'px)}',
    '.toggler svg{width:28px;height:28px}',

    '.panel{position:fixed;top:0;' + side + ':0;height:100%;width:' + PANEL_W + 'px;max-width:100vw;background:' + C.background + ';z-index:' + (Z + 1) + ';display:flex;flex-direction:column;transform:translateX(' + hiddenX + ');visibility:hidden;transition:transform .3s ease,visibility 0s linear .3s;box-shadow:' + (side === 'right' ? '-' : '') + '4px 0 24px rgba(0,0,0,.25)}',
    '.panel.open{transform:none;visibility:visible;transition:transform .3s ease,visibility 0s}',
    '.panel:focus{outline:none}',

    '.head{flex:none;height:50px;background:' + C.primary + ';color:#fff;display:flex;align-items:center;justify-content:center;position:relative}',
    '.head h2{margin:0;font-size:21px;font-weight:700;color:#fff}',
    '.close{position:absolute;' + side + ':10px;top:50%;transform:translateY(-50%);width:38px;height:38px;border:0;background:none;color:#fff;cursor:pointer;display:grid;place-items:center;padding:0;border-radius:6px}',
    '.close svg{width:24px;height:24px}',

    '.body{flex:1;overflow-y:auto;padding:18px 14px 10px;overscroll-behavior:contain}',
    '.grid{display:grid;grid-template-columns:repeat(3,1fr);gap:16px 12px;margin:0 0 22px;padding:0;list-style:none}',
    '.tile{width:100%;background:none;border:0;padding:0;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:7px;color:' + C.text + ';font-size:13px;border-radius:14px}',
    '.tile .box{width:100%;height:80px;background:#fff;border:1.5px solid #1a1a1a;border-radius:16px;display:grid;place-items:center;color:#000;transition:background-color .15s,border-color .15s,color .15s}',
    '.tile:hover .box{background:#ececec}',
    '.tile svg{width:28px;height:28px}',
    '.tile .lbl{text-align:center}',
    '.tile[aria-pressed="true"] .box{background:' + C.active + ';border-color:' + C.active + ';color:#fff}',
    '.tile[aria-pressed="true"] .lbl{color:' + C.active + ';font-weight:700}',

    '.slider{margin:0 0 24px}',
    '.slider h3{margin:0 0 10px;text-align:center;font-size:14px;font-weight:700;color:' + C.title + '}',
    '.track{position:relative;display:flex;justify-content:space-between;align-items:flex-start}',
    '.track::before{content:"";position:absolute;top:15px;left:18px;right:18px;height:6px;border-radius:3px;background:linear-gradient(to right,' + C.sliderStart + ',' + C.sliderEnd + ')}',
    '.ctl{position:relative;flex:1;display:flex;flex-direction:column;align-items:center;gap:5px;background:none;border:0;padding:0;cursor:pointer;color:' + C.text + ';font-size:12px}',
    '.ctl:first-child{align-items:flex-start}',
    '.ctl:last-child{align-items:flex-end}',
    '.ctl:disabled{opacity:.45;cursor:not-allowed}',
    '.circ{width:36px;height:36px;border-radius:50%;background:#fff;border:1.5px solid #1a1a1a;display:grid;place-items:center;color:#000}',
    '.circ svg{width:20px;height:20px}',
    '.ctl:not(:disabled):hover .circ,.ctl:not(:disabled):hover .pill{background:#ececec}',
    '.pill{min-width:54px;height:30px;margin-top:3px;padding:0 10px;border-radius:15px;background:#fff;border:1.5px solid #1a1a1a;display:grid;place-items:center;font-size:13px;font-weight:700;color:#000}',

    '.foot{border-top:1px solid #ddd;padding:14px 0 6px;text-align:center;font-size:13px;color:' + C.text + '}',
    '.foot a{color:' + C.title + ';font-weight:700}',

    // בטלפון: הפאנל משאיר פס ללשונית, והלשונית נצמדת לקצה השני של המסך
    '@media (max-width:600px){.panel{width:calc(100% - ' + BS_MOBILE + 'px)}.tile .box{height:68px}' +
      '.toggler{width:' + BS_MOBILE + 'px;height:' + BS_MOBILE + 'px;transition:' + side + ' .3s ease,background-color .2s}.toggler svg{width:21px;height:21px}' +
      '.toggler.open{transform:none;' + side + ':calc(100% - ' + BS_MOBILE + 'px)}}',
    '@media (prefers-reduced-motion:reduce){.panel,.panel.open,.toggler{transition:none}}'
  ].join('\n');

  /* ------------------------------------------------------------------ */
  /* בניית ה-DOM                                                         */
  /* ------------------------------------------------------------------ */
  var host, shadow, panel, toggler, overlay, guide, live, closeBtn;

  function tileHtml(t, i) {
    return '<li><button type="button" class="tile" data-i="' + i + '"' + (t.kind === 'reset' ? '' : ' aria-pressed="false"') + '>' +
      '<span class="box">' + ICONS[t.icon] + '</span><span class="lbl">' + t.label + '</span></button></li>';
  }
  function sliderHtml(s) {
    return '<div class="slider" role="group" aria-labelledby="sl-' + s.key + '">' +
      '<h3 id="sl-' + s.key + '">' + s.title + '</h3><div class="track">' +
      '<button type="button" class="ctl" data-s="' + s.key + '" data-a="inc"><span class="circ">' + ICONS.plus + '</span><span>' + s.inc + '</span></button>' +
      '<button type="button" class="ctl" data-s="' + s.key + '" data-a="reset" aria-label="' + s.reset + '"><span class="pill" aria-hidden="true"></span><span aria-hidden="true">' + s.reset + '</span></button>' +
      '<button type="button" class="ctl" data-s="' + s.key + '" data-a="dec"><span class="circ">' + ICONS.minus + '</span><span>' + s.dec + '</span></button>' +
      '</div></div>';
  }

  function build() {
    var style = document.createElement('style');
    style.id = 'a11y-widget-global';
    style.textContent = GLOBAL_CSS;
    document.head.appendChild(style);

    addSkipLink();

    host = document.createElement('div');
    host.id = HOST_ID;
    host.style.setProperty('display', 'block', 'important'); // תבניות Shopify מסתירות div:empty
    document.body.appendChild(host);
    shadow = host.attachShadow({ mode: 'open' });

    var top = TILES_TOP.map(function (t, i) { return tileHtml(t, i); }).join('');
    var bottom = TILES_BOTTOM.map(function (t, i) { return tileHtml(t, i + TILES_TOP.length); }).join('');

    shadow.innerHTML =
      '<style>' + WIDGET_CSS + '</style>' +
      '<div class="overlay"></div><div class="guide"></div>' +
      '<button type="button" class="toggler" aria-expanded="false" aria-controls="a11y-panel" aria-label="פתיחת תפריט נגישות">' + ICONS.person + '</button>' +
      '<div class="panel" id="a11y-panel" tabindex="-1" role="dialog" aria-modal="true" aria-labelledby="a11y-title" dir="rtl" lang="he" inert>' +
        '<div class="head"><h2 id="a11y-title">כלי נגישות</h2>' +
        '<button type="button" class="close" aria-label="סגירת תפריט נגישות">' + ICONS.close + '</button></div>' +
        '<div class="body">' +
          '<ul class="grid">' + top + '</ul>' +
          SLIDERS.map(sliderHtml).join('') +
          '<ul class="grid">' + bottom + '</ul>' +
          '<div class="foot"><a href="' + CONFIG.statementUrl + '">הצהרת נגישות</a></div>' +
        '</div>' +
      '</div>' +
      '<div class="sr-only" aria-live="polite" role="status"></div>';

    panel = shadow.querySelector('.panel');
    toggler = shadow.querySelector('.toggler');
    overlay = shadow.querySelector('.overlay');
    guide = shadow.querySelector('.guide');
    live = shadow.querySelector('[aria-live]');
    closeBtn = shadow.querySelector('.close');

    // e.detail === 0 → הופעל מהמקלדת (Enter / רווח)
    toggler.addEventListener('click', function (e) { var kb = e.detail === 0; isOpen() ? close(kb) : open(kb); });
    closeBtn.addEventListener('click', function (e) { close(e.detail === 0); });
    shadow.addEventListener('click', onPanelClick);
    shadow.addEventListener('keydown', onKeydown);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(true); });
    document.addEventListener('click', function (e) {
      if (isOpen() && e.composedPath().indexOf(host) === -1) close(false);
    });
  }

  function addSkipLink() {
    var target = document.querySelector('main, [role="main"], #MainContent, #main, #content');
    if (!target) return;
    if (!target.id) target.id = 'a11y-main-content';
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    var a = document.createElement('a');
    a.className = 'a11y-skip-link';
    a.href = '#' + target.id;
    a.textContent = 'דילוג לתוכן המרכזי';
    document.body.insertBefore(a, document.body.firstChild);
  }

  /* ------------------------------------------------------------------ */
  /* פתיחה / סגירה + מקלדת                                               */
  /* ------------------------------------------------------------------ */
  function isOpen() { return panel.classList.contains('open'); }
  // מסגרת פוקוס מוצגת רק למשתמשי מקלדת
  function open(fromKeyboard) {
    panel.removeAttribute('inert');
    panel.classList.add('open');
    toggler.classList.add('open');
    toggler.setAttribute('aria-expanded', 'true');
    setTimeout(function () { (fromKeyboard ? closeBtn : panel).focus(); }, 50);
  }
  function close(fromKeyboard) {
    panel.classList.remove('open');
    toggler.classList.remove('open');
    panel.setAttribute('inert', '');
    toggler.setAttribute('aria-expanded', 'false');
    if (fromKeyboard) toggler.focus();
    else if (shadow.activeElement) shadow.activeElement.blur();
  }
  function onKeydown(e) {
    if (e.key === 'Escape' && isOpen()) { e.stopPropagation(); close(true); return; }
    if (e.key !== 'Tab' || !isOpen()) return;
    var f = panel.querySelectorAll('button:not(:disabled), a[href]');
    var first = f[0], last = f[f.length - 1], active = shadow.activeElement;
    if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  }

  /* ------------------------------------------------------------------ */
  /* לחיצות בתפריט                                                       */
  /* ------------------------------------------------------------------ */
  function onPanelClick(e) {
    var tile = e.target.closest('.tile');
    if (tile) return onTile(ALL_TILES[+tile.dataset.i]);
    var ctl = e.target.closest('.ctl');
    if (ctl) return onSlider(ctl.dataset.s, ctl.dataset.a);
  }

  function onTile(t) {
    var on;
    if (t.kind === 'reset') {
      state = Object.assign({}, DEFAULTS);
      apply();
      return announce('כל הגדרות הנגישות אופסו');
    }
    if (t.kind === 'color') { on = state.colorMode !== t.value; state.colorMode = on ? t.value : null; }
    else if (t.kind === 'cursor') { on = state.cursor !== t.value; state.cursor = on ? t.value : null; }
    else { on = !state[t.key]; state[t.key] = on; }
    apply();
    announce(t.label + (on ? ' הופעל' : ' כובה'));
  }

  function onSlider(key, action) {
    var s = SLIDERS.filter(function (x) { return x.key === key; })[0];
    var v = state[key];
    if (action === 'inc') v = Math.min(s.max, v + s.step);
    else if (action === 'dec') v = Math.max(s.min, v - s.step);
    else v = DEFAULTS[key];
    state[key] = v;
    apply();
    announce(s.title + ': ' + s.fmt(v));
  }

  function announce(msg) {
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 30);
  }

  /* ------------------------------------------------------------------ */
  /* החלת ההגדרות על האתר                                                */
  /* ------------------------------------------------------------------ */
  var html = document.documentElement;
  function cls(name, on) { html.classList.toggle(name, !!on); }

  var FILTERS = {
    invert: 'invert(1) hue-rotate(180deg)',
    grayscale: 'grayscale(1)',
    bw: 'grayscale(1) contrast(1.6)'
  };

  function apply() {
    cls('a11y-high-contrast', state.colorMode === 'high-contrast');
    var filter = FILTERS[state.colorMode];
    overlay.style.display = filter ? 'block' : 'none';
    overlay.style.backdropFilter = overlay.style.webkitBackdropFilter = filter || '';

    cls('a11y-links', state.links);
    cls('a11y-headings', state.headings);
    cls('a11y-readable-font', state.readableFont);
    cls('a11y-hide-images', state.hideImages);
    cls('a11y-cursor-dark', state.cursor === 'dark');
    cls('a11y-cursor-light', state.cursor === 'light');
    cls('a11y-no-anim', state.noAnim);
    cls('a11y-sr', state.srAdjust);

    cls('a11y-word-spacing', state.wordSpacing !== 0);
    html.style.setProperty('--a11y-word-spacing', (state.wordSpacing * 0.1) + 'em');
    cls('a11y-letter-spacing', state.letterSpacing !== 0);
    html.style.setProperty('--a11y-letter-spacing', (state.letterSpacing * 0.04) + 'em');

    applyFontScale();
    applySrAdjust();
    setTts(state.tts);
    setReadingGuide(state.readingGuide);
    if (state.noAnim) pauseMedia();

    updateUI();
    save();
  }

  function updateUI() {
    var anyActive = false;
    shadow.querySelectorAll('.tile').forEach(function (b) {
      var t = ALL_TILES[+b.dataset.i];
      if (t.kind === 'reset') return;
      var on = t.kind === 'color' ? state.colorMode === t.value
        : t.kind === 'cursor' ? state.cursor === t.value
        : !!state[t.key];
      if (on) anyActive = true;
      b.setAttribute('aria-pressed', String(on));
    });
    SLIDERS.forEach(function (s) {
      var v = state[s.key];
      if (v !== DEFAULTS[s.key]) anyActive = true;
      shadow.querySelector('.ctl[data-s="' + s.key + '"][data-a="reset"] .pill').textContent = s.fmt(v);
      shadow.querySelector('.ctl[data-s="' + s.key + '"][data-a="reset"]').setAttribute('aria-label', s.reset + ', ערך נוכחי ' + s.fmt(v));
      shadow.querySelector('.ctl[data-s="' + s.key + '"][data-a="inc"]').disabled = v >= s.max;
      shadow.querySelector('.ctl[data-s="' + s.key + '"][data-a="dec"]').disabled = v <= s.min;
    });
    toggler.classList.toggle('has-active', anyActive);
  }

  /* --- הגדלת גופן: מכפיל את גודל הגופן המקורי של כל אלמנט --- */
  var fontOrig = new Map();
  function restoreFonts() {
    fontOrig.forEach(function (o, el) { el.style.setProperty('font-size', o.v, o.p); });
    fontOrig.clear();
  }
  function applyFontScale() {
    restoreFonts();
    var f = state.fontScale / 100;
    if (f === 1) return;
    var all = document.body.getElementsByTagName('*');
    var list = [document.body], sizes = [], i, el;
    for (i = 0; i < all.length; i++) {
      el = all[i];
      if (el === host || el instanceof SVGElement || /^(SCRIPT|STYLE|NOSCRIPT|TEMPLATE|LINK|META|BR|IFRAME)$/.test(el.tagName)) continue;
      list.push(el);
    }
    for (i = 0; i < list.length; i++) sizes.push(parseFloat(getComputedStyle(list[i]).fontSize)); // קריאה מרוכזת
    for (i = 0; i < list.length; i++) {                                                            // כתיבה מרוכזת
      el = list[i];
      if (!sizes[i]) continue;
      fontOrig.set(el, { v: el.style.getPropertyValue('font-size'), p: el.style.getPropertyPriority('font-size') });
      el.style.setProperty('font-size', (sizes[i] * f).toFixed(2) + 'px', 'important');
    }
  }

  /* --- התאמה לקוראי מסך: משלים תיאורים חסרים --- */
  function mark(el, attr, value) {
    el.setAttribute(attr, value);
    var m = el.getAttribute('data-a11y-added');
    el.setAttribute('data-a11y-added', m ? m + ' ' + attr : attr);
  }
  function applySrAdjust() {
    if (!state.srAdjust) {
      document.querySelectorAll('[data-a11y-added]').forEach(function (el) {
        el.getAttribute('data-a11y-added').split(' ').forEach(function (a) { el.removeAttribute(a); });
        el.removeAttribute('data-a11y-added');
      });
      return;
    }
    if (!html.lang) mark(html, 'lang', 'he');
    document.querySelectorAll('img:not([alt])').forEach(function (img) { mark(img, 'alt', img.title || ''); });
    document.querySelectorAll('a[href], button, [role="button"]').forEach(function (el) {
      if (el.getAttribute('aria-label') || el.getAttribute('aria-labelledby') || el.textContent.trim()) return;
      var img = el.querySelector('img[alt]:not([alt=""])');
      var name = el.title || (img && img.alt) || (el.tagName === 'A' ? 'קישור' : 'כפתור');
      mark(el, 'aria-label', name);
    });
    document.querySelectorAll('input:not([type=hidden]):not([type=submit]):not([type=button]), select, textarea').forEach(function (el) {
      if (el.getAttribute('aria-label') || el.getAttribute('aria-labelledby') || el.closest('label') ||
          (el.id && document.querySelector('label[for="' + CSS.escape(el.id) + '"]'))) return;
      var name = el.placeholder || el.title || el.name;
      if (name) mark(el, 'aria-label', name);
    });
    document.querySelectorAll('iframe:not([title])').forEach(function (f) { mark(f, 'title', 'תוכן מוטמע'); });
  }

  /* --- הקראת טקסט (Web Speech API) --- */
  var ttsOn = false, ttsTimer = null, ttsCurrent = null, heVoice = null;
  var TTS_SEL = 'a,button,[role=button],[role=link],h1,h2,h3,h4,h5,h6,p,li,label,td,th,img,input,select,textarea,figcaption,blockquote,summary';
  function pickVoice() {
    var v = window.speechSynthesis ? speechSynthesis.getVoices() : [];
    heVoice = v.filter(function (x) { return /^(he|iw)/i.test(x.lang); })[0] || null;
  }
  function speak(text) {
    if (!window.speechSynthesis || !text) return;
    speechSynthesis.cancel();
    var u = new SpeechSynthesisUtterance(text);
    u.lang = 'he-IL';
    if (heVoice) u.voice = heVoice;
    speechSynthesis.speak(u);
  }
  function describe(el) {
    var tag = el.tagName, role = el.getAttribute('role');
    var text = el.getAttribute('aria-label') || '';
    if (!text) {
      if (tag === 'IMG') text = el.alt;
      else if (/^(INPUT|SELECT|TEXTAREA)$/.test(tag)) text = (el.labels && el.labels[0] && el.labels[0].innerText) || el.placeholder || el.value;
      else text = el.innerText;
    }
    text = (text || '').replace(/\s+/g, ' ').trim().slice(0, 500);
    if (!text) return '';
    var prefix = (tag === 'A' || role === 'link') ? 'קישור: '
      : (tag === 'BUTTON' || role === 'button') ? 'כפתור: '
      : /^H[1-6]$/.test(tag) ? 'כותרת: '
      : tag === 'IMG' ? 'תמונה: ' : '';
    return prefix + text;
  }
  function onTtsEvent(e) {
    var t = e.target;
    if (!(t instanceof Element) || t === host) return;
    clearTimeout(ttsTimer);
    ttsTimer = setTimeout(function () {
      var el = t.closest(TTS_SEL);
      if (!el) {
        if (t.children.length) return; // לא מקריאים מכולות גדולות (div עוטף וכו')
        el = t;
      }
      if (el === ttsCurrent) return;
      var text = describe(el);
      if (!text) return;
      if (ttsCurrent) ttsCurrent.classList.remove('a11y-tts-current');
      ttsCurrent = el;
      el.classList.add('a11y-tts-current');
      speak(text);
    }, e.type === 'focusin' ? 0 : 300);
  }
  function setTts(on) {
    if (on && !window.speechSynthesis) {
      state.tts = false;
      announce('הדפדפן אינו תומך בהקראת טקסט');
      return;
    }
    if (on === ttsOn) return;
    ttsOn = on;
    var m = on ? 'addEventListener' : 'removeEventListener';
    document[m]('mouseover', onTtsEvent, true);
    document[m]('focusin', onTtsEvent, true);
    if (on) {
      pickVoice();
      if (speechSynthesis.onvoiceschanged !== undefined) speechSynthesis.onvoiceschanged = pickVoice;
    } else {
      clearTimeout(ttsTimer);
      speechSynthesis.cancel();
      if (ttsCurrent) ttsCurrent.classList.remove('a11y-tts-current');
      ttsCurrent = null;
    }
  }

  /* --- מדריך קריאה --- */
  var guideOn = false;
  function moveGuide(e) { guide.style.transform = 'translateY(' + e.clientY + 'px)'; }
  function setReadingGuide(on) {
    if (on === guideOn) return;
    guideOn = on;
    guide.style.display = on ? 'block' : 'none';
    document[on ? 'addEventListener' : 'removeEventListener']('mousemove', moveGuide, { passive: true });
  }

  /* --- ביטול אנימציות: עצירת וידאו בהפעלה אוטומטית --- */
  function pauseMedia() {
    document.querySelectorAll('video[autoplay], video').forEach(function (v) { try { v.pause(); } catch (e) { /* ignore */ } });
  }

  /* --- תוכן שנטען דינמית (סל קניות, סליידרים וכו') --- */
  var moTimer = null;
  function watchDom() {
    new MutationObserver(function (records) {
      if (state.fontScale === 100 && !state.srAdjust) return;
      var added = records.some(function (r) {
        for (var i = 0; i < r.addedNodes.length; i++) {
          var n = r.addedNodes[i];
          if (n.nodeType === 1 && n !== host) return true;
        }
        return false;
      });
      if (!added) return;
      clearTimeout(moTimer);
      moTimer = setTimeout(function () {
        if (state.fontScale !== 100) applyFontScale();
        if (state.srAdjust) applySrAdjust();
      }, 400);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ------------------------------------------------------------------ */
  function init() {
    build();
    apply();
    watchDom();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
